import { CountdownAd } from 'components/CountdownAd/themes/BGH-RD3/countdownAd';
import { CountdownAd as CountdownAdModel } from 'models/CountdownAd';
import { NO_ELEMENT } from 'utils';
import styles from './countdownContainer.scss';
import { Section } from 'components/Section';

interface OwnProps {
  ad?: CountdownAdModel;
}

export const CountdownContainer = ({ ad }: OwnProps) => {
  if (!ad) {
    return NO_ELEMENT;
  }

  return (
    <Section className={styles.countdownSection}>
      <div className={styles.countdownBlock}>
        <CountdownAd {...ad} className={styles.contentPage} appearance={'content-page'} />
      </div>
    </Section>
  );
};
